import { OwcBackdrop, OwcProgressSpinner } from '@one/react';
import { PropsWithChildren } from 'react';
import { ErrorOrChildren } from './error-or-children.component';

interface LoadableComponentProps extends PropsWithChildren {
  isLoading: boolean;
  isError?: boolean;
}

export const LoadableComponent: React.FC<LoadableComponentProps> = props => {
  const { children, isLoading, isError = false } = props;

  return isLoading ? (
    <OwcBackdrop disableScrollLock opacity={0}>
      <OwcProgressSpinner variant="secondary" size="xxLarge" />
    </OwcBackdrop>
  ) : (
    <ErrorOrChildren isError={isError}>{children}</ErrorOrChildren>
  );
};
